export const POPUP_PAGE_SIZE = 20;